import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Activate.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Activate.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/user-activation/Activate.vue?vue&type=script&lang=js&
// module id = 397
// module chunks = 0